<template>
    <div class="inputcounter">
        <v-btn tile small color="teal" icon depressed :ripple="false" class="inputcounter-btn-left" @click="decrease()" :disabled="isDecreaseDisabled">
            <v-icon size="18">{{mdiMinus}}</v-icon>
        </v-btn>

        <input 
			type="text" v-model="value" v-on:keyup.down.prevent="decrease()" v-on:keyup.up.prevent="increase()" 
			:class="{hideLeftBorder : isDecreaseDisabled, hideRightBorder : isIncreaseDisabled}"
		>

        <v-btn tile small color="none" icon depressed :ripple="false" class="inputcounter-btn-right" @click="increase()" :disabled="isIncreaseDisabled">
            <v-icon size="18">{{mdiPlus}}</v-icon>
        </v-btn>
    </div>
</template>

<script>
    import {
        mdiMinus,
        mdiPlus,
	} from '@mdi/js';
	
    export default {
        name: 'inputcounter',
        props: {
            count: {
                default: 0
            },
            min: {
                default: 0
            },
            max: {
                default: 999999
            },
        },
        model: {
            prop: 'count',
            event: 'input'
        },
        data: () => ({
            mdiMinus: mdiMinus,
            mdiPlus: mdiPlus,

            value: 0
        }),
        watch: {
            count: function(n) {
				this.value = parseInt(n) || 0 
			},
            value: function(n) {
                var x = parseInt(n) || 0;
                x = x < this.getMin ? this.getMin : x;
                x = x > this.getMax ? this.getMax : x;
                this.$emit("input", parseInt(x))
                if (x != this.value) {
                    this.value = x
                }
            }
        },
        mounted() {
            this.value = parseInt(this.count) || 0
        },
        methods: {
            decrease(event) {
                if (!this.isDecreaseDisabled) {
                    this.value--;
                }
                if (event) {
                    event.preventDefault();
                }
            },
            increase(event) {
                if (!this.isIncreaseDisabled) {
                    this.value++;
                }
                if (event) {
                    event.preventDefault();
                }
            },
        },
        computed: {
            getMin() {
                return parseInt(this.min) || 0
            },
            getMax() {
                return parseInt(this.max) || 999999
			},
			isDecreaseDisabled(){
				return this.value <= this.getMin
			},
			isIncreaseDisabled(){
				return this.value >= this.getMax
			},
        }
    }
</script>

<style lang="less">
    .inputcounter {
        display: flex;

        input {
            border: 1px solid #c7c7c7;
            text-align: center;
            width: 50px;
            background-color: #fff;
            outline: none;
			font-weight: 700;
			border-left: none;
			border-right: none;
			&.hideLeftBorder{
				border-left-color: #c7c7c7;
			}
			&.hideRightBorder{
				border-right-color: #c7c7c7;
			}
        }

        button {
            background-color: #4285f4;
            border-color: #4285f4;
            transition: all .3s;

            &:hover {
                background-color: #2064d3;
                border-color: #2064d3;
            }

            svg {
                path {
                    fill: #fff;
                }
            }

            &.v-btn--disabled {
                background-color: #c7c7c7;
                border-color: #c7c7c7;
            }

            &.inputcounter-btn-left {
                border-radius: 4px 0 0 4px;
            }

            &.inputcounter-btn-right {
                border-radius: 0 4px 4px 0;
            }
        }
    }
</style>